module.exports = __webpack_public_path__ + "static/media/14_sognolucido.4a543eb3.jpg";